import {observable, action, runInAction} from 'mobx'
import { json } from '../../../../utils/ajax'

class productDetail {
  @observable loading
  @observable detailData
  @observable attrlist
  @observable describe
  @observable attrParams
  @observable attrType4
  @observable number
  @observable attrimgs
  @observable recommended
  @observable carseriesNameList
  @observable boutiqueGoodsImgs

  constructor() {
    this.loading = false
    this.detailData = {}
    this.attrlist = []
    this.describe = ''
    this.attrParams = []
    this.attrType4 = []
    this.attrimgs = []
    this.recommended = []
    this.number = 0
    this.carseriesNameList = []
    this.boutiqueGoodsImgs = []
  }


  @action
  getDetailData = async (id) => {
    const DetailData = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/${id}`)
    if (DetailData && DetailData.status === 0) {
      return
    }
    const attrlist = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/attr/attrList`)
    if (DetailData && DetailData.status === 0) {
      return
    }
    const recommended = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activity/receptionShortActivityGoods`)
    if (recommended && recommended.status === 0) {
      return
    }

    const describe = DetailData.boutiqueGoodsAttrs.find(item => item.attrId === 15)
    const attrParams = []
    const attrType4 = []
    attrlist.forEach(item => {
      if (item.field !== 4 && item.id !== 15) {
        const text = DetailData.boutiqueGoodsAttrs.find(a => a.attrId === item.id)
        if(text) {
          attrParams.push({
            id: item.id,
            name: item.name,
            text: text.attrItemImg&&item.field === 3 ? text.attrItemImg.split(',') : text.attrItemText
          })
        }
      }
      if (item.field === 4){
        const text = DetailData.boutiqueGoodsAttrs.find(a => a.attrId === item.id)
        if(text) {

          attrType4.push({
            name: item.name,
            text:text.attrItemText
          })
        }
      }
    })
    const attrimgs = DetailData.boutiqueGoodsImgs
    const number = attrParams.find(item => item.id === 14)?attrParams.find(item => item.id === 14).text:''
    runInAction(() => {
      this.detailData = DetailData
      this.boutiqueGoodsImgs = DetailData.boutiqueGoodsImgs
      this.carseriesNameList = this.detailData.carseries.split(",")
      this.attrlist = attrlist
      this.describe = describe && describe.attrItemText
      this.attrParams = attrParams
      this.attrType4 = attrType4
      this.attrimgs = attrimgs
      this.recommended = recommended
      this.number = number
    })
  }

}

export default new productDetail()


// WEBPACK FOOTER //
// ./src/project/dongfeng/products/Details/store.js